export enum createAccountStatus {
  USER_ALREADY_CREATED = 'user_already_created',
}
